var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"card-title-help dyor-logo",attrs:{"target":"_blank","href":"https://dyor.io/"}},[_c('icon-title-help',{staticClass:"card-title-help__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('jetton_filters.dyor.data_from' ))+" DYOR.io")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }